import type { SubEntryType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ModalBody } from "@tandemdiabetes/sugarmate-react-components"

import { useEntryModalPrivateContext } from "../EntryModalPrivateContext"
import { SubEntryFooter } from "../SubEntryFooter"
import { SubEntryHeader } from "../SubEntryHeader"
import { useUpdateActivity } from "../useUpdateActivity"

import { GlucoseRangeInput } from "./GlucoseRangeInput"
import { GlucoseValueWarning } from "./GlucoseValueWarning"
import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props {
  currentSubEntry: EditableSubEntry<ActivityType.Glucose>;
  updateSubEntry: (s: Partial<EditableSubEntry<ActivityType.Glucose>>) => void;
  currentUserEntry: EditableUserEntry;
  setCurrentUserEntry: (userEntry: EditableUserEntry) => void;
}

export function GlucoseForm(props: Props) {
  const {
    currentSubEntry,
    updateSubEntry,
    currentUserEntry,
    setCurrentUserEntry,
  } = props

  const { glucose: activity } = currentSubEntry

  const updateActivity = useUpdateActivity(
    ActivityType.Glucose,
    activity,
    updateSubEntry,
  )

  const { readOnly } = useEntryModalPrivateContext()

  const SaveWarning = !activity?.mg_dl
    ? GlucoseValueWarning
    : undefined

  return (
    <>
      <SubEntryHeader
        activityType={ActivityType.Glucose}
        currentSubEntry={currentSubEntry}
        currentUserEntry={currentUserEntry}
        setCurrentUserEntry={setCurrentUserEntry}
        readOnly={readOnly}
        closeBtnId="glucose-entry-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        <GlucoseRangeInput
          activity={activity}
          updateActivity={updateActivity}
          readOnly={readOnly}
        />
        <SubEntryFooter
          currentSubEntry={currentSubEntry}
          currentUserEntry={currentUserEntry}
          updateSubEntry={
            updateSubEntry as (
              s: Partial<EditableSubEntry<SubEntryType>>
            ) => void
          }
          readOnly={readOnly}
          SaveWarning={SaveWarning}
        />
      </ModalBody>
    </>
  )
}
